"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _semanticUiReact = require("semantic-ui-react");

var _Colors = require("../00_environment/Colors");

var _Fonts = require("../00_environment/Fonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = function Button(_ref) {
  var primary = _ref.primary,
      style = _ref.style,
      to = _ref.to,
      color = _ref.color,
      onClick = _ref.onClick,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["primary", "style", "to", "color", "onClick", "children"]);

  var defaultStyle = (0, _Fonts.withDefaultFont)({
    color: _Colors.onDarkTextColor,
    borderRadius: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  });

  if (primary) {
    defaultStyle.backgroundColor = _Colors.primaryColor;
  } else if (!color) {
    defaultStyle.backgroundColor = _Colors.defaultButtonColor;
  } else if (color.indexOf('#') === 0) {
    defaultStyle.backgroundColor = color;
  }

  var as;

  if (to && !onClick) {
    as = _reactRouterDom.Link;
  }

  var buttonContent = /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, _extends({
    as: as,
    to: to,
    color: color && color.indexOf('#') === -1 ? color : null,
    style: Object.assign(defaultStyle, style),
    onClick: onClick
  }, rest), children);
  /*
  if (to && !onClick) {
     buttonContent = <Link to={to}>{buttonContent}</Link>;
  } */


  return buttonContent;
};

var _default = Button;
exports["default"] = _default;